import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagConsumoEnCompraFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagConsumoEnCompra'>
      {({ field }) => (
        <Form.Checkbox {...field} checked={iValue} disabled={fIsSubmitting} id='checkbox-flagConsumoEnCompra' label='Consumo en Compra' />
      )}
    </Field>
  )
}

export default React.memo(FlagConsumoEnCompraFormGroup)
